module.exports = [{"type":"title","text":"2025-09-01"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"U本位永續合約：新增交易規則接口"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2025-09-01.json
// module id = w96y
// module chunks = 3